module.exports = __webpack_public_path__ + "img/business-english-es.5be4a6ea.png";